import { Action, createReducer, on } from '@ngrx/store';

import { LocalSite, setSiteOwner, setSiteStatus, SiteExtTechAcl, SiteStatus } from 'src/app/model/site';
import * as SiteMapActions from './site-map.actions';

export interface State {
    sites: SiteStatus[];
    sitesExtTechAcl: SiteExtTechAcl[];
    localsites: LocalSite[];
}

const initialState: State = {
    sites: [],
    sitesExtTechAcl: [],
    localsites: []
};

const siteMapReducer = createReducer(
    initialState,
    on(SiteMapActions.getSitesDataSuccess, (state, payload) => ({ ...state, sites: payload.sites.map(s => new SiteStatus(s)) })),
    on(SiteMapActions.getSiteStatusDataSuccess, (state, payload) => {
        const siteS = state.sites.find(ss => ss.SiteId === payload.siteId);
        if (!siteS) {
            return { ...state };
        }
        const newSites = state.sites.filter(s => s.SiteId !== payload.siteId);
        return { ...state, sites: [...newSites, setSiteStatus(siteS, payload.deviceStatus)] };
    }),
    on(SiteMapActions.getSiteOwnerSuccess, (state, payload) => {
        const siteS = state.sites.find(ss => ss.SiteId === payload.siteId);
        if (!siteS) {
            return { ...state };
        }
        const newSites = state.sites.filter(s => s.SiteId !== payload.siteId);
        return { ...state, sites: [...newSites, setSiteOwner(siteS, payload.user)] };
    }),
    on(SiteMapActions.getSitesExtTechAclSuccess, (state, payload) => {
        const sitesExt = payload.sites;
        return { ...state, sitesExtTechAcl: sitesExt };
    }),
    on(SiteMapActions.getLocalsitesSuccess, (state, payload) => {
        const localsites = payload.localsites;
        return { ...state, localsites: localsites };
    }),
);

export const reducer = (state: State | undefined, action: Action): State => siteMapReducer(state, action);

